var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Row', [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_vm._v(_vm._s(_vm.field))]), _c('Col', {
    staticClass: "pre ratio",
    attrs: {
      "span": "6"
    }
  }, [_vm._v(_vm._s(_vm.preRatio))]), _c('Col', {
    staticClass: "ratio",
    style: _vm.diffStyle,
    attrs: {
      "span": "5"
    }
  }, [_vm._v(_vm._s(_vm.diffRatio))]), _c('Col', {
    staticClass: "ratio",
    attrs: {
      "span": "6"
    }
  }, [_vm._v(_vm._s(_vm.currentRatio))])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }